import { localizePath, t } from './i18n';
import { absoluteUrl, applySocialMeta } from './seo/social-meta';

function applySupportCopy(): void {
    applySocialMeta({
        title: t('meta.supportTitle'),
        description: t('meta.supportDescription'),
        url: absoluteUrl(localizePath('/support.html')),
        twitterCard: 'summary_large_image',
    });

    const intro = document.getElementById('support-intro');
    if (intro) intro.textContent = t('support.intro');

    const cta = document.getElementById('support-cta');
    if (cta) {
        cta.innerHTML = `${t('support.cta')} <a href="mailto:feedback@calendarify.online">feedback@calendarify.online</a>`;
    }

    const faqHeading = document.getElementById('faq-heading');
    if (faqHeading) faqHeading.textContent = t('support.faqHeading');

    const pairs: Array<[string, string, 'support.qMobile' | 'support.qPdf' | 'support.qTablet', 'support.aMobile' | 'support.aPdf' | 'support.aTablet']> = [
        ['faq-q-mobile', 'faq-a-mobile', 'support.qMobile', 'support.aMobile'],
        ['faq-q-pdf', 'faq-a-pdf', 'support.qPdf', 'support.aPdf'],
        ['faq-q-tablet', 'faq-a-tablet', 'support.qTablet', 'support.aTablet'],
    ];

    for (const [qId, aId, qKey, aKey] of pairs) {
        const q = document.getElementById(qId);
        const a = document.getElementById(aId);
        if (q) q.textContent = t(qKey);
        if (a) a.textContent = t(aKey);
    }
}

document.addEventListener('DOMContentLoaded', applySupportCopy);
